export default __webpack_public_path__ + "static/media/LatestTrade.315ec38d.svg";